import { useContext } from 'react';
import { CareerPageContext } from 'context/CareerPageContext';

const useCareerPageContext = () => {
  const ctx = useContext(CareerPageContext);
  return { ...ctx };
};

export default useCareerPageContext;
